import { createAction } from '@reduxjs/toolkit';
import { AgentApiLeadCloseReason, AgentApiLeadStatus } from '../../modules/b2b/api';

export const fetchB2BLeadsAction = createAction<{
  status?: AgentApiLeadStatus;
  mine?: boolean;
  beforeId?: number;
  perPage?: number;
  reset?: boolean;
}>('FETCH_B2B_LEADS');

export const selectB2BLeadAction = createAction<{ id: string }>(
  'SELECT_B2B_LEAD'
);

export const takeB2BLeadAction = createAction<{ id: string }>(
  'TAKE_B2B_LEAD'
);

export const updateB2BLeadAction = createAction<{
  id: string;
  lead: {
    status?: AgentApiLeadStatus;
    close_reason?: AgentApiLeadCloseReason;
    agency_user_id?: number | null;
  };
}>('UPDATE_B2B_LEAD');
